/**
 * Collection Showcase Navigation
 * Handles dynamic switching between collections in dropdown menu
 */

(function() {
  function initCollectionShowcase(container) {
    if (container.dataset.showcaseInit) return;
    container.dataset.showcaseInit = 'true';
    
    const menuItems = container.querySelectorAll('.collection-menu-item');
    const descriptions = container.querySelectorAll('.collection-description-content');
    const images = container.querySelectorAll('.collection-showcase-img-wrapper');
    
    menuItems.forEach(item => {
      item.addEventListener('mouseenter', function() {
        switchCollection(this);
      });
      
      item.addEventListener('click', function() {
        // Don't prevent default - allow navigation to collection page
        switchCollection(this);
      });
    });
    
    function switchCollection(selectedItem) {
      const collectionIndex = selectedItem.dataset.collectionIndex;

      menuItems.forEach(item => item.classList.remove('active'));
      descriptions.forEach(desc => desc.classList.remove('active'));
      images.forEach(img => img.classList.remove('active'));

      selectedItem.classList.add('active');
      
      const targetDescription = container.querySelector(
        `.collection-description-content[data-collection-index="${collectionIndex}"]`
      );
      const targetImage = container.querySelector(
        `.collection-showcase-img-wrapper[data-collection-index="${collectionIndex}"]`
      );

      if (targetDescription) targetDescription.classList.add('active');
      if (targetImage) targetImage.classList.add('active');
    }
  }

  function initAll() {
    document.querySelectorAll('.navigation__collection-showcase').forEach(function(showcase) {
      initCollectionShowcase(showcase);
    });
  }

  // Try multiple initialization points
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  
  // Re-init when navigation becomes visible (for dropdowns)
  setTimeout(initAll, 100);
  setTimeout(initAll, 500);
})();

